import {createFileRoute} from '@tanstack/react-router';

import {UsersAdminPage} from '@/modules/settings/pages/UsersAdminPage';

export const Route = createFileRoute('/_authenticated/account/users')({
  component: UsersAdminPage,
});
